import { FC } from 'react';
import { Box } from '@mui/material';

import { DashboardPageContainer } from '@carcareers/components';

interface EmployerDemoProps {
  idReplacement: string;
  videoUrl: string;
  height?: string | number;
}

export const EmployerDemo: FC<EmployerDemoProps> = ({ idReplacement, videoUrl, height = 'auto' }) => {
  return (
    <DashboardPageContainer idReplacement={idReplacement}>
      <Box
        sx={{
          mt: 5,
          borderRadius: 2,
          overflow: 'hidden',
          boxShadow: 3,
        }}
      >
        <video
          controls
          controlsList="nodownload"
          width="100%"
          height={height}
          style={{
            display: 'block',
            borderRadius: 'inherit',
          }}
        >
          <source src={videoUrl} type="video/mp4" />
          <source src={videoUrl} type="video/webm" />
          <source src={videoUrl} type="video/ogg" />
          Your browser does not support the video tag.
          <a href={videoUrl} target="_blank" rel="noopener noreferrer">View in New Tab</a>
        </video>
      </Box>
    </DashboardPageContainer>
  );
};

export default EmployerDemo;
